import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import Box from "@material-ui/core/Box"
import TextField from "@material-ui/core/TextField"
import makeStyles from "@material-ui/core/styles/makeStyles"
import WidgetRowInfo from "./WidgetRowInfo"
import { WidgetDataType, WidgetViewModelType } from "./WidgetPropTypes"

const useStyles = makeStyles(() => ({
  // Quick'n dirty solution to be able tu use document.execCommand API
  // this is so ugly... but command copy doesn't work if HTML component is hidden
  // it has to be displayed...
  hiddenTextPreserveElement: {
    height: "1px",
    width: "1px",
    overflow: "hidden",
    position: "absolute"
  }
}))

/**
 * Simple Skeleton wrapper, that handle Widget view model fields properly.
 * Its children is used to display first row that is title / subtitle part.
 */
export default function SkeletonInfoCard({
  className,
  widgetData,
  widgetViewModel,
  inputRef,
  children
}) {
  const classes = useStyles()
  return (
    <Box className={className}>
      {children}
      <Box className="widget-data" mt={1}>
        {_.map(_.toPairs(widgetViewModel), (entry, idx) => (
          <WidgetRowInfo
            key={`${idx}-${entry[0]}`}
            name={entry[0]}
            value={entry[1]}
          />
        ))}
      </Box>
      <TextField
        className={classes.hiddenTextPreserveElement}
        value={JSON.stringify(widgetData)}
        inputRef={inputRef}
        multiline
      />
    </Box>
  )
}

SkeletonInfoCard.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  widgetViewModel: WidgetViewModelType.isRequired,
  widgetData: WidgetDataType,
  inputRef: PropTypes.object.isRequired
}

SkeletonInfoCard.defaultProps = {
  widgetData: undefined
}
